import { Tooltip } from "antd";
import { useContext } from "react";
import { UserContext } from "../Contexts/UserContext";
import { PeFilterContext } from "../Contexts/PeFilterContext";
import { useLocation } from "react-router";

const ToggleDealsViewButton = ({handleChartIconClick}) => {
    const {isDirectoryUser} = useContext(UserContext);
    const {
        dealsView, 
        setDealsView, 
        toggleDealsBtn, 
        setToggleDealsBtn,
        showChartPopup,
        setShowChartPopup,
        isChartRedirect
    } = useContext(PeFilterContext);

    const { pathname } = useLocation();

    
    const dealsViewHandler = (checked) => {
        setDealsView(checked);
        if (checked) {
            setShowChartPopup(false);
        }
    };

    const companiesViewHandler = () => {
        setDealsView(false);
        setShowChartPopup(false);
    };

    const chartViewHandler = () => {
        setDealsView(false);
        setShowChartPopup(true);
        handleChartIconClick()
    };

  return (
    <>
      {!isDirectoryUser && !isChartRedirect && (
        <div className={`py-2 md:py-3 w-auto md:w-auto flex justify-center md:justify-start flex-shrink-0`}>
          <div className="flex bg-white rounded-xs border p-0.5">
            {/* Deals View State */}
            {dealsView && !showChartPopup ? (
              <>
                <div
                  className={`w-13 md:w-24 p-3 py-0 text-sm border-r border-gray-500 ${
                    dealsView ? "bg-[#ad7907] rounded-xs text-white" : "bg-white"
                  }  transition-all duration-200 delay-200`}
                >
                  <button><span className="hidden md:inline">Deals View</span><span className="inline md:hidden">Deals</span></button>
                </div>
                <Tooltip placement="bottom" title="Switch To Companies View">
                  <div
                    className={`w-13 md:w-24 p-3 py-0 text-sm bg-white
                      transition-all duration-200 delay-200 ${!pathname.includes("all") ? "border-r border-gray-500" : ""}`}
                  >
                    <button onClick={companiesViewHandler}><span className="hidden md:inline">Cos. View</span><span className="inline md:hidden">Cos</span></button>
                  </div>
                </Tooltip>
                {!pathname.includes("all") && <Tooltip placement="bottom" title="Switch To Chart View">
                  <div
                    className={`w-13 md:w-24 p-3 py-0 text-sm bg-white
                      transition-all duration-200 delay-200`}
                  >
                    <button onClick={chartViewHandler} aria-label="chart-view-button"><span className="hidden md:inline">Chart View</span><span className="inline md:hidden">Table</span></button>
                  </div>
                </Tooltip>}
              </>
            ) : showChartPopup && !dealsView ? (
              /* Chart View State */
              <>
                <Tooltip placement="bottom" title="Switch To Deals View">
                  <div
                    className={`w-16 md:w-24 p-3 py-0 text-sm border-r border-gray-500 bg-white
                      transition-all duration-200 delay-200`}
                  >
                    <button onClick={() => dealsViewHandler(true)}><span className="hidden md:inline">Deals View</span><span className="inline md:hidden">Deals</span></button>
                  </div>
                </Tooltip>
                <Tooltip placement="bottom" title="Switch To Companies View">
                  <div
                    className={`w-13 md:w-24 p-3 py-0 text-sm border-r border-gray-500 bg-white
                      transition-all duration-200 delay-200`}
                  >
                    <button onClick={companiesViewHandler}><span className="hidden md:inline">Cos. View</span><span className="inline md:hidden">Cos</span></button>
                  </div>
                </Tooltip>
                {!pathname.includes("all") && <div
                  className={`w-13 md:w-24 p-3 py-0 text-sm ${
                    showChartPopup ? "bg-[#ad7907] rounded-xs text-white" : "bg-white"
                  }  transition-all duration-200 delay-200`}
                >
                  <button><span className="hidden md:inline">Chart View</span><span className="inline md:hidden">Table</span></button>
                </div>}
              </>
            ) : (
              /* Companies View State */
              <>
                <Tooltip placement="bottom" title="Switch To Deals View">
                  <div
                    className={`w-13 md:w-24 p-3 py-0 text-sm border-r border-gray-500 bg-white
                      transition-all duration-200 delay-200`}
                  >
                    <button onClick={() => dealsViewHandler(true)}><span className="hidden md:inline">Deals View</span><span className="inline md:hidden">Deals</span></button>
                  </div>
                </Tooltip>
                <div
                  className={`w-13 md:w-24 p-3 py-0 text-sm border-r border-gray-500 ${
                    !dealsView && !showChartPopup ? "bg-[#ad7907] rounded-xs text-white" : "bg-white"
                  }  transition-all duration-200 delay-200`}
                >
                  <button><span className="hidden md:inline">Cos. View</span><span className="inline md:hidden">Cos</span></button>
                </div>
                {!pathname.includes("all") && <Tooltip placement="bottom" title="Switch To Chart View">
                  <div
                    className={`w-13 md:w-24 p-3 py-0 text-sm bg-white
                      transition-all duration-200 delay-200`}
                  >
                    <button onClick={chartViewHandler} aria-label="chart-view-button"><span className="hidden md:inline">Chart View</span><span className="inline md:hidden">Table</span></button>
                  </div>
                </Tooltip>}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ToggleDealsViewButton;
